import { useEffect } from 'react';

import type { UseAccessRightsTabEffectsProps } from '@app/pages/Users/AccessRightsTab/types';

export const useAccessRightsTabEffects = ({
  getAccessRightsTemplatesHandler,
  checkHasChanges,
}: UseAccessRightsTabEffectsProps) => {
  useEffect(() => {
    getAccessRightsTemplatesHandler();
  }, [getAccessRightsTemplatesHandler]);

  useEffect(() => {
    checkHasChanges();
  }, [checkHasChanges]);
};
